let context;
export function unlockSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    if (!context) context = new AudioContext();
    if (context.state === 'suspended') context.resume().catch(() => { /* Browser autoplay policy may deny audio; slicing stays available. */ });
  } catch { /* Gameplay remains available without audio. */ }
}
export function playSound(kind = 'slice') {
  try {
    unlockSound();
    if (!context || context.state !== 'running') return;
    const now = context.currentTime;
    const tone = (frequency, at, duration, volume = .08, endFrequency = frequency) => {
      const osc = context.createOscillator(), gain = context.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(frequency, at);
      osc.frequency.exponentialRampToValueAtTime(endFrequency, at + duration);
      gain.gain.setValueAtTime(.001, at);
      gain.gain.exponentialRampToValueAtTime(volume, at + .008);
      gain.gain.exponentialRampToValueAtTime(.001, at + duration);
      osc.connect(gain); gain.connect(context.destination);
      osc.start(at); osc.stop(at + duration + .01);
      osc.onended = () => { osc.disconnect(); gain.disconnect(); };
    };
    if (kind === 'slice') {
      tone(1100, now, .09, .04, 150);
      tone(240, now + .06, .1, .075, 80);
    } else {
      const celebratory = kind === 'celebrate' || kind === 'legendary';
      const notes = kind === 'legendary' ? [523.25,659.25,783.99,1046.5,1318.5] : celebratory ? [523.25,659.25,783.99,1046.5] : [659.25,880,1046.5];
      notes.forEach((frequency, i) => tone(frequency, now + .22 + i * .075, celebratory ? .34 : .24, celebratory ? .07 : .05));
      if(celebratory) tone(523.25,now+.48,.45,.025);
    }
  } catch { /* No audio permission or unsupported device. */ }
}
export function haptic(level = 'ordinary') {
  try {
    if(navigator.vibrate) navigator.vibrate(level === 'perfect' ? [14,35,22,40,14] : level === 'excellent' ? [12,30,16] : 6);
  } catch { /* Optional enhancement; Safari may not expose vibration. */ }
}
